function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { InputNumber } from 'mkui-fd';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var CurrencyInput = /*#__PURE__*/function (_React$Component) {
  _inherits(CurrencyInput, _React$Component);

  function CurrencyInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CurrencyInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CurrencyInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "changeHandle", function (number) {
      var onChange = _this.props.onChange;
      onChange(number);
    });

    _defineProperty(_assertThisInitialized(_this), "blurHandle", function (e) {
      var onBlur = _this.props.onBlur;
      var value = Number(_this.parser(e.target.value));
      onBlur(value, e);
    });

    _defineProperty(_assertThisInitialized(_this), "formatter", function (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });

    _defineProperty(_assertThisInitialized(_this), "parser", function (value) {
      var reg = new RegExp(',', 'g');
      return value.replace(reg, '');
    });

    return _this;
  }

  _createClass(CurrencyInput, [{
    key: "render",
    value: function render() {
      var _rootCls,
          _this2 = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          precision = _this$props.precision,
          symbol = _this$props.symbol,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          value = _this$props.value,
          theme = _this$props.theme;
      var isSymbol = CurrencyInput.allSymbol.includes(symbol);
      var rootCls = (_rootCls = {}, _defineProperty(_rootCls, prefixCls, 1), _defineProperty(_rootCls, "text", !isSymbol), _defineProperty(_rootCls, "symbol", isSymbol), _rootCls);
      var s = CurrencyInput.getSymbol(symbol);
      return React.createElement("div", {
        className: classNames(rootCls)
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-symbol")
      }, s), React.createElement(InputNumber, {
        max: 999999999999999,
        value: value,
        placeholder: placeholder,
        precision: precision,
        disabled: disabled,
        onChange: this.changeHandle,
        className: "mkui-currency-input-number",
        formatter: function formatter(formattervalue) {
          return _this2.formatter(formattervalue);
        },
        parser: function parser(parseValue) {
          return _this2.parser(parseValue);
        },
        theme: theme,
        onBlur: this.blurHandle
      }));
    }
  }], [{
    key: "getSymbol",
    value: function getSymbol(symbol) {
      return symbol === 'CNY' ? '￥' : symbol;
    }
  }]);

  return CurrencyInput;
}(React.Component);

_defineProperty(CurrencyInput, "propTypes", {
  prefixCls: PropTypes.string,
  precision: PropTypes.number,
  symbol: PropTypes.string,
  disabled: PropTypes.bool,
  nonnegative: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.number,
  theme: PropTypes.string,
  onBlur: PropTypes.func
});

_defineProperty(CurrencyInput, "defaultProps", {
  prefixCls: 'mkui-currency-input',
  precision: 2,
  symbol: '',
  disabled: false,
  nonnegative: false,
  value: 0,
  theme: undefined,
  onChange: function onChange() {},
  onBlur: function onBlur() {}
});

_defineProperty(CurrencyInput, "allSymbol", ['￥', '$', '€', '￡']);

export { CurrencyInput as default };
//# sourceMappingURL=index.js.map
